/**
 * Human-readable labels for the platform's fixed mode vocabulary
 * (APP_SPEC §6; docs/APP_PLAN.md §7.5's `mode` column). Purely
 * presentational and platform-neutral — every game declares which of
 * these modes it supports in its own metadata (`supportedModes`), never
 * the other way around (CLAUDE.md §2).
 */
const MODE_LABELS: Record<string, string> = {
  solo: 'Solo',
  async_multiplayer: 'Two player',
  round_multiplayer: 'Round-based multiplayer',
};

export function modeLabel(mode: string): string {
  return MODE_LABELS[mode] ?? mode;
}
